module.exports = __webpack_public_path__ + "img/PH.b79a563d.png";